import { createContext } from 'react';

export const sTypeGrpIdContext = createContext<string | null>(null);
